import React, { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import { Box } from "@mui/material";
import { Sun, Moon } from "lucide-react";

const ThemeSwitcher = () => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <Box
            onClick={toggleTheme}
            sx={{
                width: "64px",
                height: "32px",
                borderRadius: "16px",
                backgroundColor: isDark ? "#1d1929" : "#e5e5e5",
                position: "relative",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 6px",
                border: isDark ? "2px solid rgba(255, 255, 255, 0.1)" : "2px solid rgba(0, 0, 0, 0.1)",
                "&:hover": {
                    backgroundColor: isDark ? "#252132" : "#d5d5d5",
                }
            }}
        >
            <Sun 
                size={16} 
                color={isDark ? "#666" : "#f59e0b"}
                style={{ 
                    zIndex: 1,
                    transition: "color 0.3s ease"
                }}
            />
            <Moon 
                size={16} 
                color={isDark ? "#bac0ff" : "#666"}
                style={{ 
                    zIndex: 1,
                    transition: "color 0.3s ease"
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    width: "24px",
                    height: "24px",
                    borderRadius: "12px",
                    backgroundColor: isDark ? "#bac0ff" : "#fff",
                    boxShadow: isDark 
                        ? "0 2px 8px rgba(186, 192, 255, 0.4)" 
                        : "0 2px 8px rgba(0, 0, 0, 0.2)",
                    left: isDark ? "calc(100% - 30px)" : "4px",
                    transition: "left 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            />
        </Box>
    );
};

export default ThemeSwitcher;
